import { makeStyles } from 'tss-react/mui';

const useStylesProductForm = makeStyles()((theme) => {
    return {
        productRoot: {
            width: '40vw',
            maxWidth: '600px',
            height: '100vh !important',
            padding: theme.spacing(5, 7, 3),
        },
        scroll: {
            display: 'flex',
            flexDirection: 'column',
            overflowX: 'hidden',
            /* Hide scrollbar for IE, Edge and Firefox */
            scrollbarWidth: 'none',
            /* Hide scrollbar for Chrome, Safari and Opera */
            '&::-webkit-scrollbar': {
                display: 'none',
            },
        },

        optionsRow: {
            display: 'flex',
            alignItems: 'center',
        },

        buttonStyle: {
            paddingRight: theme.spacing(0.5),
            borderRadius: theme.spacing(2),
            fontSize: '12px',
            lineHeight: '1.3',
            width: '100%',
            textTransform: 'uppercase',
            height: theme.spacing(4.25),
            fontWeight: '500',
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(1),
            marginBottom: theme.spacing(1),
            [theme.breakpoints.up('xl')]: {
                height: '42px',
                borderRadius: theme.custom.borderRadiusLarge,
                fontSize: '14px',
                fontWeight: '600',
            },
        },

        addButton: {
            fontWeight: '500',
            '&:hover': {
                backgroundColor: 'red',
                color: '#fff',
                fontWeight: '600',
            },
            color: '#3283D3',
            [theme.breakpoints.up('xl')]: {
                fontWeight: '600',
                '&:hover': {
                    fontWeight: '700',
                },
            },
        },

        addOption: {
            width: theme.spacing(18),
            height: theme.spacing(4),
            background: '#FFFFFF 0% 0% no-repeat padding-box',
            border: '1px solid #00000021',
            borderRadius: theme.spacing(2),
            fontWeight: '500',
            textTransform: 'uppercase',
            '&:hover': {
                backgroundColor: 'red',
                color: '#fff',
                fontWeight: '600',
            },
            color: '#000',
            [theme.breakpoints.up('xl')]: {
                fontWeight: '600',
                '&:hover': {
                    fontWeight: '700',
                },
            },
        },

        saveButton: {
            color: '#FFF',
            fontWeight: '600',
            [theme.breakpoints.up('xl')]: {
                fontWeight: '600',
            },
        },

        positionEnd: {
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
        },

        variantOption: {
            width: 'fit-content',
            wordBreak: 'break-word',
        },

        variantRowSpan: {
            fontSize: '0.75rem',
            fontFamily: 'Montserrat',
            lineHeight: '1.5',
        },

        productForm: {
            display: 'flex',
            flexDirection: 'column',
            overflowX: 'hidden',
            height: '100%',
        },

        variantContent: {
            background: ' #FFFFFF 0% 0% no-repeat padding-box',
            border: '1px solid #00000021',
            borderRadius: '10px',
        },

        mtNeg10px: {
            marginTop: '-10px',
        },

        p10px: {
            padding: '10px',
        },

        pb10px: {
            paddingBottom: '10px',
        },

        mlr10px: {
            margin: '0px 10px 0px',
        },

        pt10px: {
            paddingTop: '10px',
        },

        mb20px: {
            marginBottom: '20px',
        },

        varOptText: {
            fontWeight: 'bold',
        },

        editVariant: {
            borderRadius: '10px 10px 0px 0px',
            background: 'red',
            color: '#FFFFFF',
        },

        divider: {
            marginLeft: '12px',
            marginRight: '4px',
            height: '20px',
            [theme.breakpoints.up('xl')]: {
                height: '24px',
                marginLeft: '15px',
                marginRight: '5px',
            },
        },

        dividerColor: {
            background: '#FFFFFF',
        },

        autocomplete: {
            width: 'auto !important',
            borderRadius: theme.spacing(2),
            '& .MuiAutocomplete-inputRoot': {
                padding: '4px !important',
                height: '36px',
            },

            '& .MuiChip-root': {
                borderRadius: '5px',
                border: '1px solid #00000021',
                cursor: 'pointer',
                height: '26px',
                /* margin: 2px; */
                display: 'flex',
                fontSize: '12px',
                background: '#F5F5F5',
                '& svg': {
                    width: '14px',
                    color: 'gray',
                },
            },
        },

        descriptionError: {
            '& > div': {
                border: '1px solid red !important',
            },
        },

        uploadImageButtonBig: {
            height: '100% !important',
            borderRadius: '10px !important',
        },
    };
});

export default useStylesProductForm;
